import rene from "../../Images/(Above_Footer)-Industries_Pg.webp";
import { useNavigate } from "react-router-dom";

const IndustriesContactSection = () => {
  const navigate = useNavigate();

  const handleGetInTouch = () => {
    navigate("/contact");
  };
  return (
    <section
      className="min-h-[80vh] flex items-center"
      style={{
        background: "linear-gradient(to bottom, #A19784, #020202)",
      }}
      data-aos="fade-up"
    >
      <div className="container mx-auto px-4 py-12">
        <div
          className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16"
          data-aos="fade-up"
        >
          {/* Left Side - Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <img
                src={rene}
                alt="Middle Eastern cityscape at sunset"
                className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-lg shadow-2xl"
              />
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="w-full lg:w-1/2">
            <div className="max-w-lg mx-auto lg:mx-0">
              {/* Header */}
              <div className="mb-8">
                <p className="text-[#FFFFFFBF] text-sm mb-2">
                  Need Any Consultations
                </p>
                <h2 className="text-4xl md:text-5xl font-bold text-white">
                  Contact Us
                </h2>
              </div>

              {/* Contact Form */}
              <form className="space-y-6">
                {/* First Row - Name and Email */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      placeholder="Name"
                      className="w-full px-0 py-3 bg-transparent border-0 border-b border-[#FFFFFF59] focus:border-[#C99C48] focus:outline-none focus:ring-0
 text-gray-100 placeholder-[#FFFFFFBF] transition-colors duration-300"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      placeholder="E-mail address"
                      className="w-full px-0 py-3 bg-transparent border-0 border-b border-[#FFFFFF59] focus:border-[#C99C48] focus:outline-none focus:ring-0
 text-gray-100 placeholder-[#FFFFFFBF] transition-colors duration-300"
                    />
                  </div>
                </div>

                {/* Second Row - Phone and Company */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="tel"
                      placeholder="Phone"
                      className="w-full px-0 py-3 bg-transparent border-0 border-b border-[#FFFFFF59] focus:border-[#C99C48] focus:outline-none focus:ring-0
 text-gray-100 placeholder-[#FFFFFFBF] transition-colors duration-300"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Company Name"
                      className="w-full px-0 py-3 bg-transparent border-0 border-b border-[#FFFFFF59] focus:border-[#C99C48] focus:outline-none focus:ring-0
 text-gray-100 placeholder-[#FFFFFFBF] transition-colors duration-300"
                    />
                  </div>
                </div>

                {/* Message Field */}
                <div>
                  <textarea
                    placeholder="Message"
                    rows={4}
                    className="w-full px-0 py-3 bg-transparent border-0 border-b border-[#FFFFFF59] focus:border-[#C99C48] focus:outline-none focus:ring-0
 text-gray-100 placeholder-[#FFFFFFBF] resize-none transition-colors duration-300"
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="pt-4">
                  <button
                    type="button"
                    onClick={handleGetInTouch}
                    className="bg-[#C99C48] hover:bg-[#C99C48] text-white font-medium py-3 px-8 rounded-lg transition-colors duration-300 transform hover:scale-105"
                  >
                    Get in Touch
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesContactSection;
